/* eslint-disable wrap-iife */
"use strict";
var $ = require("jquery");
const moment = require("moment");
import { isSafari, isMobileSafari } from 'react-device-detect';

import { RX } from './constants';

module.exports = function () {
    /* private properties and methods */
    let me = {};

    /* public properties and methods */
    me.init = (moduleName, model, flex = window.flex, browserHistory = flex.browserHistory) => {
        if (!flex) {
            flex = window.flex;
        }

        flex.onTrigger("global:refresh", function (params) {
            const store = flex.getStore(true);
            store.set({ refreshAt: new Date() });
        });

        flex.onTrigger("global:navigate", function (params) {
            if (!params || !params.url) return;

            if (params.replace) {
                browserHistory.replace(params.url);
            } else {
                if (isSafari || isMobileSafari) {
                    window.location.href = params.url;
                } else {
                    browserHistory.push(params.url);
                }
            }
        });

        flex.onTrigger("global:session-loggedin", function (params) {
            const store = flex.getStore(true);
            // This is one of two places this structure is defined.  
            // The other is server side in WebHelper.GetJsonModel()
            const session = !params.session || !params.session.user ? false : {
                token: params.session.token,
                expireIn: params.session.expireIn,
                expiresAt: params.session.expiresAt,
                serverTime: params.session.serverTime,
                user: {
                    id: params.session.user.id,
                    personId: params.session.user.personId,
                    summary: params.session.user.summary,
                    username: params.session.user.username
                },
                blockedIssues: params.session.blockedIssues,
                downgradedIssues: params.session.downgradedIssues,
                warnedIssues: params.session.warnedIssues,
                ignoredIssues: params.session.ignoredIssues
            };

            //flex.storage("session", session);
            //store.set({ session: session });
            flex.setCookie({ key: "flex-st", value: session.token })
            if (params.then) params.then();
            //flex.trigger("global:session-updated", params.session);
        });
        flex.onTrigger("global:session-timeout", function (params) {
            //Calculate how long until we are X minutes away from a session timeout
            var expiresAt = moment(params.expiresAt);
            var timeToExpire = moment.duration(expiresAt.diff(moment()));
            var serverOffset = moment.duration(moment(params.serverTime).diff(moment()));
            timeToExpire.subtract({ minutes: params.sessionIdleTimeoutWarningMinutes });
            timeToExpire.subtract(serverOffset);
            // Do this once we are x minutes away from a timeout
            setTimeout(function () {
                //Verify that the session expiresAt hasn't been updated by getting it from the server
                $.ajax({
                    url: flex.getApiUrl("/api/v1/auth/getsession"),
                    async: true,
                    type: "get",
                    cache: false,
                    data: { token: params.token },
                    headers: flex.getHeaders(),
                    success: function (data) {
                        //Calculate how long until we are X minutes away from a session timeout
                        var expiresAt = moment(data.session.expiresAt);
                        //Time remaining until session expires
                        var timeToExpire = moment.duration(expiresAt.diff(moment()));
                        //Calculate and subtract the server offset.
                        var serverOffset = moment.duration(moment(data.serverTime).diff(moment()));
                        timeToExpire.subtract(serverOffset);
                        //Time remaining until we should warn about session expiration
                        var timeToWarning = moment.duration(expiresAt.diff(moment())).subtract({ minutes: params.sessionIdleTimeoutWarningMinutes });
                        if (timeToWarning._milliseconds <= 0) {
                            //Time to warn them, prompt with an option to extend.
                            var timeoutPrompt = flex.timeoutPrompt({
                                title: "Session expiring",
                                message: `Your current session will <b>Expire</b> soon.  Please click <b>OK</b> if you wish to continue. </br></br> Time Remaining: <b>{{TIMEOUT}}</b>`,
                                timeRemaining: timeToExpire,
                                serverTime: data.serverTime,
                                expiresAt: expiresAt,
                                onExpire: () => {
                                    // I think we need to check again here if you are expired or not. If you open a new tab or something your session could have 
                                    // been extended.
                                    $.ajax({
                                        url: flex.getApiUrl("/api/v1/auth/getsession"),
                                        async: true,
                                        type: "GET",
                                        cache: false,
                                        data: { token: params.token, RefreshExpiration: false },
                                        headers: flex.getHeaders(),
                                        success: function (data) {
                                            //Calculate how long until we are X minutes away from a session timeout
                                            var expiresAt = moment(data.session.expiresAt);
                                            //Time remaining until session expires
                                            var timeToExpire = moment.duration(expiresAt.diff(moment()));
                                            var serverOffset = moment.duration(moment(data.serverTime).diff(moment()));
                                            timeToExpire.subtract(serverOffset);
                                            if (timeToExpire <= 0) {
                                                flex.redirect(`/`);
                                            }
                                            else {
                                                //Session successfully extended, take the new session's data and do this all again!                                               
                                                flex.timeoutPrompt(false);
                                                flex.trigger("global:session-timeout", {
                                                    expiresAt: data.session.expiresAt, token: params.token, serverTime: data.serverTime,
                                                    sessionIdleTimeoutWarningMinutes: params.sessionIdleTimeoutWarningMinutes
                                                });
                                            }
                                        }.bind(this),
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            // In this case we knew we were probably expired so need to redirect
                                            flex.redirect(`/`);
                                        }
                                    });


                                },
                                //Should this live in the timeout prompt? 
                                // I like the timeout prompt to do one thing and just notify when something changes. I'd keep this stuff here.
                                onClose: () => {
                                    //Call get session, but with RefreshExpiration as true.  Do this to extend the time that this session is active.
                                    $.ajax({
                                        url: flex.getApiUrl("/api/v1/auth/getsession"),
                                        async: true,
                                        type: "GET",
                                        cache: false,
                                        data: { token: params.token, RefreshExpiration: true },
                                        cache: false,
                                        headers: flex.getHeaders(),
                                        success: function (data) {
                                            //Session successfully extended, take the new session's data and do this all again!
                                            console.log("Session extended!");
                                            flex.timeoutPrompt(false);
                                            flex.trigger("global:session-timeout", {
                                                expiresAt: data.session.expiresAt, token: params.token, serverTime: data.serverTime,
                                                sessionIdleTimeoutWarningMinutes: params.sessionIdleTimeoutWarningMinutes
                                            });
                                        }.bind(this),
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            // Do we need some better error handling here?
                                            flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                                        }
                                    });
                                },
                            });
                        } else {
                            // The session has been refreshed since we last checked.  Recuse again on the new expiresAt from the session.
                            flex.trigger("global:session-timeout", {
                                expiresAt: data.session.expiresAt, token: params.token, serverTime: data.serverTime,
                                sessionIdleTimeoutWarningMinutes: params.sessionIdleTimeoutWarningMinutes
                            });
                        }
                    }.bind(this),
                    error: function (jqXHR, textStatus, errorThrown) {

                        console.log(jqXHR);
                    }
                });
            }, timeToExpire._milliseconds);
        });
        flex.onTrigger("global:session-loggedout", function (params) {
            const store = flex.getStore(true);
            const token = store && store.session && store.session.token ? store.session.token : false;
            flex.removeCookie("flex-st");
            flex.storage("session", false);
            flex.clearSessionStorage();
            store.remove("prompt").remove("modal").remove("session");
            if (!token) return;

            flex.setStore({ showFullScreenLoader: true });
            flex.setBusy("global:session-loggedout", true, store);
            $.ajax({
                url: flex.getApiUrl("/api/v1/auth/expiresession"),
                async: true,
                type: "post",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify({ token: token }),
                headers: flex.getHeaders(),
                success: function (data) {
                    //flex.setBusy("global:session-loggedout", false, store);
                    //flex.redirect("/");
                    flex.setStore({ showFullScreenLoader: false });
                    flex.setBusy("global:session-loggedout", false, store);
                    flex.redirect();
                }.bind(this),
                error: function (jqXHR, textStatus, errorThrown) {
                    //flex.redirect("/");
                    flex.setStore({ showFullScreenLoader: false });
                    flex.setBusy("global:session-loggedout", false, store);
                    flex.redirect();
                }
            });

        });
        flex.onTrigger("global:session-change-user-org", function (options) {
            const store = flex.getStore(true);
            flex.setStore({ showFullScreenLoader: true });
            const requestData = { userOrgId: options.userOrgId };

            if (options.userOrgId) {
                const store = flex.getStore(true);

                $.ajax({
                    url: flex.getApiUrl("/api/v1/auth/changesessionuserorg"),
                    async: true,
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(requestData),
                    headers: flex.getHeaders(),
                    success: function (data) {
                        flex.setStore({});
                        sessionStorage.clear();
                    }.bind(this),
                    error: function (jqXHR, textStatus, errorThrown) {
                        flex.setStore({});
                        sessionStorage.clear();
                    },
                    complete: function () {
                        window.location.reload(true);
                    }
                });
            }
        });
        flex.onTrigger("global:api-auth-failed", function (params) {
            flex.addPageAlerts({ kind: "api-exception", className: "alert-danger", summary: "Access Denied!  Try logging out and logging back in...", selfCloseTimeout: 10000 });
        });
        flex.onTrigger("global:localText-get", function (params) {
            // Fetch local text and update state
            var path = params.path;
            // If we're testing from a different locale, replace the default (en-US) with the one stored in the cookie.
            const localeCookie = flex.getCookie("flex-locale");
            if (localeCookie) {
                path = path.replace("en-US", localeCookie);
            }
            const store = flex.getStore(true);
            const localText = flex.debug ? false : flex.storage(path);
            if (localText) {
                const store = flex.getStore(true);
                let appContext = store.appContext.toJS();
                appContext.nav = flex.getTopNav(appContext, localText);
                store.set({ localText: localText, appContext: appContext });
            }
            else
                $.get(path, function (data) {
                    // set timeout just to simulate lag in fetch
                    setTimeout(function () {
                        if (!flex.debug) flex.storage(path, data);
                        const store = flex.getStore(true);
                        path = path + "org=" + store.appContext.app.org.id;
                        let appContext = store.appContext.toJS();
                        appContext.nav = flex.getTopNav(appContext, data);
                        store.set({ localText: typeof data == "object" ? data : {}, appContext: appContext });
                    }, 0);
                });
        });
        flex.onTrigger("global:load-config-codes", function (codeKinds, success, error) {
            // Fetch config codes if not already in store
            const store = flex.getStore(true);
            let configCodes = store.configCodes;
            _.remove(codeKinds, (kind) => { return configCodes && configCodes[kind]; });
            const requestData = { codeKinds: codeKinds };

            if (codeKinds && codeKinds.length) {
                flex.setBusy("global:load-config-codes", true);
                $.ajax({
                    url: flex.getApiUrl("/api/v1/config/getcodes"),
                    async: true,
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(requestData),
                    headers: flex.getHeaders(),
                    success: function (data) {
                        if (!this.unmounting && data.codes && data.codes) {
                            const store = flex.getStore(true);
                            let configCodes = store.configCodes;
                            if (configCodes) configCodes.set(data.codes);
                            else store.set({ configCodes: data.codes });
                        }
                        flex.setBusy("global:load-config-codes", false);
                        if (success) {
                            success();
                        }
                    }.bind(this),
                    error: function (jqXHR, textStatus, errorThrown) {
                        flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                        flex.setBusy("global:load-config-codes", false);
                        if (error) {
                            error();
                        }
                    }
                });
            }
        });
        flex.onTrigger("global:ping", function (params) {
            flex.ping();
        });
        flex.onTrigger("global:ping-success", function (params) {
            const store = flex.getStore(true);
            store.set({ pingFailedAt: false });
        });
        flex.onTrigger("global:ping-failed", function (params) {
            const store = flex.getStore(true);
            store.set({ pingFailedAt: new Date() });
        });
        flex.onTrigger("global:api-exception", function (params) {
            const summary = params && params.jqXHR && params.jqXHR.responseText ? params.jqXHR.responseText : "Unknown Error";
            flex.addPageAlerts([{ kind: "api-exception", summary: summary.replace(/(^")|("$)/g, '') }])
        });
        flex.onTrigger("global:add-page-alerts", function (newAlerts) {
            const store = flex.getStore(true);
            const alerts = store.pageAlerts ? store.pageAlerts.toJS() : [];
            const maxKey = alerts.length ? _.max(_.map(alerts, (alert) => { return alert.key })) : 0;
            const alertsToAdd = Array.isArray(newAlerts) ? newAlerts : [newAlerts];
            //flex.log("alerts", _.map(alerts, (alert) => { return alert.key}));
            store.set({
                pageAlerts: _.slice(_.concat(alertsToAdd.map((newAlert, i) => {
                    newAlert.key = newAlert.key || (new Date().getTime() + '_' + i); return newAlert;
                }), alerts), 0, 5)
            });
        });
        flex.onTrigger("global:remove-page-alerts", function (keys, postId) {
            const store = flex.getStore(true);
            const alerts = store.pageAlerts ? store.pageAlerts.toJS() : [];
            const keysToRemove = Array.isArray(keys) ? keys : [keys];
            _.remove(alerts, (existingAlert) => { return _.indexOf(keysToRemove, existingAlert.key) >= 0 });

            if (postId) {
                flex.trigger("global:mark-post-as-read", [postId]);

                sessionStorage["alert_" + postId] = "true";
            }

            store.set({ pageAlerts: alerts });
        });

        flex.onTrigger("global:add-page-modal-content", function (newContent) {
            const store = flex.getStore(true);
            const pageModalContent = store.pageModalContent ? store.pageModalContent.toJS() : [];
            const maxKey = pageModalContent.length ? _.max(_.map(pageModalContent, (content) => { return content.key })) : 0;
            const contentToAdd = Array.isArray(newContent) ? newContent : [newContent];
            store.set({ pageModalContent: _.slice(_.concat(contentToAdd.map((newContent, i) => { newContent.key = (maxKey + 1 + i); return newContent; }), pageModalContent), 0, 5) });
        });
        flex.onTrigger("global:remove-page-modal-content", function (keys, postId) {
            const store = flex.getStore(true);
            const pageModalContent = store.pageModalContent ? store.pageModalContent.toJS() : [];
            const keysToRemove = Array.isArray(keys) ? keys : [keys];
            _.remove(pageModalContent, (existingContent) => { return _.indexOf(keysToRemove, existingContent.key) >= 0 });

            if (postId) {
                flex.trigger("global:mark-post-as-read", [postId]);
            }

            store.set({ pageModalContent: pageModalContent });
        });

        flex.onTrigger("global:subscribe-to-signalr-group", function (groupId, triggerName) {
            const store = flex.getStore(true);
            let signalRGroups = store.signalRGroups ? store.signalRGroups.toJS() : [];            
            signalRGroups.push({groupId, triggerName});             
            flex.setStore({signalRGroups});        
          
        });

        flex.onTrigger("global:get-app-posts", function () {
            const store = flex.getStore(true);

            const isLogoutPage = location.pathname.endsWith('logout');

            if (store && store.session && store.session.user && !isLogoutPage) {
                $.ajax({
                    url: flex.getApiUrl("/api/v1/post/getglobalcontent"),
                    async: true,
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify({}),
                    headers: flex.getHeaders(),
                    success: function (data) {
                        let alerts = [];
                        let requiredContent = [];

                        data.siteContent.map(function (content) {
                            const sessionStorageKey = 'alert_' + content.id;

                            if (content.type === 'SiteAlert') {
                                if (!content.showOnLogin || (content.showOnLogin && sessionStorage[sessionStorageKey] == null)) {
                                    alerts.push({ kind: "api-exception", className: "alert-danger", summary: content.content, postId: content.id, isModal: content.isRequired });
                                }

                            }
                            else if (content.type == 'SiteModal') {
                                if (sessionStorage[sessionStorageKey] == null) {
                                    requiredContent.push({ backdrop: true, summary: content.content, postId: content.id, isRequired: content.isRequired, allowDoNotShowAgain: content.allowDoNotShowAgain, modalClass:'welcome-modal' });
                                    //Don't show this message again if its been seen
                                    sessionStorage[sessionStorageKey] = true;
                                }

                            }
                            else if (content.isRequired) {
                                if (!sessionStorage[sessionStorageKey]) {
                                    requiredContent.push({
                                        backdrop: 'static',
                                        summary: content.content,
                                        postId: content.id,
                                        isRequired: content.isRequired
                                    });
                                    sessionStorage[sessionStorageKey] = true;
                                }
                            }
                        }.bind(this));
                        flex.addPageAlerts(alerts);
                        flex.addPageModalContent(requiredContent);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                        flex.setStore({ error: errorThrown });
                    }
                });
            }
        });

        flex.onTrigger(
          "global:save-orguser-selected-language",
          function (token) {
            const localStorageKey = "selectedLanguage";
            const localStorageStringData = localStorage.getItem(localStorageKey);

            if (!localStorageStringData) {
              return;
            }

            const localStorageData = JSON.parse(localStorageStringData);

            const store = flex.getStore(true);
            const isLogoutPage = location.pathname.endsWith("logout");

            if (store && token && !isLogoutPage) {
              const requestHeader = {Authorization: "Bearer " + token, ...flex.getHeaders()};

              const getLanguageURL = flex.getApiUrl(
                "/api/v1/org/getorguserselectedlanguage"
              );
              $.ajax({
                url: getLanguageURL,
                async: false,
                type: "post",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify({}),
                headers: requestHeader,
                success: (res) => {
                  //localStorageData.SelectedLanguageUpdatedAt is in UNIX Time Format
                  const localStorageUpdatedAt = moment.unix(
                    localStorageData?.selectedLanguageUpdatedAt
                  );

                  //userData.SelectedLanguageUpdatedAt is in ISO 8601 Time Format
                  const userUpdatedAt = moment(
                    new Date(res?.selectedLanguageUpdatedAt)
                  );

                  if (
                    !res.selectedLanguage ||
                    (localStorageUpdatedAt.isAfter(userUpdatedAt) &&
                      res.selectedLanguage !==
                        localStorageData.selectedLanguage)
                  ) {
                    const saveLanguageURL = flex.getApiUrl(
                      "/api/v1/org/saveorguserselectedlanguage"
                    );
                    $.ajax({
                      url: saveLanguageURL,
                      async: false,
                      type: "post",
                      dataType: "json",
                      contentType: "application/json",
                      data: JSON.stringify({
                        SelectedLanguage: localStorageData.selectedLanguage,
                      }),
                      headers: requestHeader,
                      success: function () {
                          console.log(
                              `Saved ${localStorageData.selectedLanguage} as User Preference Language`
                            );
                      },
                      error: function (jqXHR, textStatus, errorThrown) {
                        flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                        flex.setStore({ error: errorThrown });
                      },
                    });
                  }
                }
              }).catch(function (error) {
                flex.setStore({ error: error });
              });
            }
          }
        );
        
        flex.onTrigger("global:vinSearch", function (params) {
            $.ajax({
                url: flex.getApiUrl("/api/v1/workbench/getvinbysearch"),
                async: false,
                type: "post",
                dataType: "json",
                traditional: true,
                data: { Vin: params.vin },
                headers: flex.getHeaders(),
                success: function (data) {
                    const store = flex.getStore();
                    let result = data.vinResult || [];
                    let vins = result || [];
                    if (vins.length > 0) {
                        if (vins.length == 1) {
                            flex.setStore({ singleVin: vins })
                            flex.log("singleVin", vins);
                        }
                        else {
                            flex.setStore({ Vin: vins });
                            flex.log("vin", vins);
                        }
                    }
                    else {
                        flex.setStore({ Vin: [], singleVin: [] });
                        var error = flex.text("INVALID_VIN", "Invalid VIN");
                        var param = { message: error, type: "error" }
                        flex.trigger("global:showAlert", param);
                    }
                }.bind(this),
                error: function (jqXHR, textStatus, errorThrown) {
                    flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                    flex.setStore({ Vin: [], singleVin: [] });
                }
            });
        });
        flex.onTrigger("global:showAlert", function (params) {
            let className = 'alert-success'
            if (params.type == "error") {
                className = 'alert-danger';
            }
            let message = params.message;
            if (params.error != undefined) {
                //summary = params.error.JSON
            }
            var alert = [{ kind: "api-exception", className: className, summary: message }];
            flex.setStore({ pageAlerts: [] });
            flex.addPageAlerts(alert);
            window.scrollTo(0, 0);
        });
        flex.onTrigger("global:mark-post-as-read", function (postIds) {
            let requestData = { postIds };

            $.ajax({
                url: flex.getApiUrl("/api/v1/post/markpostsasread"),
                async: true,
                type: "post",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(requestData),
                headers: flex.getHeaders(),
                success: function (data) {
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                }
            });
        });
        flex.onTrigger("global:ListingUpdated", function (listingId) {
            console.warn(listingId);
		});
		flex.onTrigger("global:display-session-issues", function () {
			var issues = [];
			// If there are any blocking, downgrading, or warning issues, display them here.
			issues = model.session.personIssues ? issues.concat(model.session.personIssues) : issues;
			issues = model.session.dealerIssues ? issues.concat(model.appContext.userContext.currentContext.dealerIssues) : issues;

			issues ? issues.filter(issue => !_.isEmpty(issue.displayMessage)).forEach((issue) => {
				if (issue.personIssueAffectsAllDealerships != "Ignore") {
					flex.addPageAlerts({ className: issue.personIssueAffectsAllDealerships == "Warning" ? "alert-info" : "alert-danger", summary: issue.displayMessage, hideText: issue.acknowledged });
				}
			}) : false;
		});
		flex.onTrigger("global:handle-buyer-auth", function () {
			const store = flex.getStore();
			const session = store.session;
			let requestData = {
				"sessionId": session.id,
				"token": session.token,
				"userId": session.user.id,
				"appOrgId": store.appContext.userContext.currentContext.targetOrg.id,
				"userOrgId": store.appContext.userContext.currentContext.userOrg.id
			};

			$.ajax({
				url: flex.getApiUrl("/api/v1/auth/handlebuyerauth"),
				async: true,
				type: "post",
				dataType: "json",
				contentType: "application/json",
				data: JSON.stringify(requestData),
				headers: flex.getHeaders(),
				success: function (data) {
					flex.setStore({ showFullScreenLoader: true });
					setTimeout(function () {
						window.location.reload(1);
					}, 2000);
				},
				error: function (jqXHR, textStatus, errorThrown) {
					flex.handleAjaxError(jqXHR, textStatus, errorThrown);
				}
			});
		});

        flex.onTrigger(RX.TERMS_AND_CONDITIONS.CLEAR_BRANCH, () => {
            const initBranchState = {
                isLoading: false,
                invalidDealers: []
            };
        
            flex.setStore({
                termsAndConditions: {
                    ...initBranchState
                }
            });
        });

        flex.onTrigger(RX.TERMS_AND_CONDITIONS.GET_DEALERS_INFO, () => {
            const setStore = (property, value) => {
                const { termsAndConditions } = flex.getStore().toJS();
            
                termsAndConditions[property] = value;
            
                flex.setStore({
                    termsAndConditions
                });
            };

            setStore('isLoading', true);

            FlexApiRequest.POST({
                path: '/api/v1/auth/gettcdealerinfo'
            })
                .send({})
                .then((response) => {
                    const { tcContentUrl, invalidDealers } = response.data;

                    setStore('invalidDealers', invalidDealers);
                    setStore('tcContentUrl', tcContentUrl);

                    if (!invalidDealers.length) {
                        sessionStorage.setItem('terms-and-conditions:checked-dealers', true);
                    }
                })
                .catch((error, closeTime = 10000) => {
                    error.handledErrors.forEach(handledError => {
                        flex.addPageAlerts({
                            summary: handledError.summary,
                            selfCloseTimeout: closeTime
                        });
                    });
                })
                .finally(() => {
                    setStore('isLoading', false);
                });
        });

        flex.onTrigger(RX.TERMS_AND_CONDITIONS.ACCEPT_DEALERS, (invalidDealers) => {
            FlexApiRequest.POST({
                path: '/api/v1/auth/sendtcacceptanceinfo'
            })
                .send({ accountNumbers: invalidDealers.map(({ accountNumber }) => accountNumber) })
                .then(() => {
                    sessionStorage.setItem('terms-and-conditions:checked-dealers', true);
                    location.reload();
                })
                .catch((error, closeTime = 10000) => {
                    error.handledErrors.forEach(handledError => {
                        flex.addPageAlerts({
                            summary: handledError.summary,
                            selfCloseTimeout: closeTime
                        });
                    });
                });
        });

        // set context
        let { appContext } = flex.getStore().toJS();
        flex.apiBaseUrl = appContext && appContext.app && appContext.app.api ? appContext.app.api : flex.apiBaseUrl;
        if (moduleName) appContext.moduleName = moduleName;

        // set model
        model = model || {};
		model.appContext = appContext;
		console.log("App context", appContext);
		var storedSession = flex.storage("session")
		console.log("Storage session", storedSession);
        model.session = appContext.session || flex.storage("session");

        let isOAuthEnabled = flex.isFeatureToggleEnabled("UseOAuthFlow");

        model.session && model.session.token ? flex.setCookie({ key: "flex-st", value: isOAuthEnabled ? model.session.oAuthToken : model.session.token }) : flex.removeCookie("flex-st");
        flex.setStore(model);
        flex.trigger("global:localText-get", { path: appContext.localTextPath });
        flex.trigger("global:session-timeout", {
            expiresAt: model.session.expiresAt, token: model.session.token, serverTime: model.session.serverTime,
            sessionIdleTimeoutWarningMinutes: model.appContext.app.passwordConfig.sessionIdleTimeoutWarningMinutes
		});
		flex.trigger("global:display-session-issues");

        if (moduleName !== "public") flex.trigger("global:ping");
    };

    return me;
}();